/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialV2FormConfiguration
 */
export interface ProviderCredentialV2FormConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showTargetBranch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showAgencyId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showAgentName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showAgentPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showPCC?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showSubscriptionKey?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showTarget?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showB2BAPIUserPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showB2BAPIUserEmailAddress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showServiceUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showClientId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showClientSecret?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showAuthenticationUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showAccessGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showShoppingUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showShoppingClientId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showShoppingClientSecret?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showShoppingServiceUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showPostShoppingUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showPostShoppingClientId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showPostShoppingClientSecret?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    showPostShoppingServiceUrl?: boolean;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof ProviderCredentialV2FormConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
}

export function ProviderCredentialV2FormConfigurationFromJSON(json: any): ProviderCredentialV2FormConfiguration {
    return ProviderCredentialV2FormConfigurationFromJSONTyped(json, false);
}

export function ProviderCredentialV2FormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2FormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showTargetBranch': !exists(json, 'showTargetBranch') ? undefined : json['showTargetBranch'],
        'showAgencyId': !exists(json, 'showAgencyId') ? undefined : json['showAgencyId'],
        'showAgentName': !exists(json, 'showAgentName') ? undefined : json['showAgentName'],
        'showAgentPassword': !exists(json, 'showAgentPassword') ? undefined : json['showAgentPassword'],
        'showPCC': !exists(json, 'showPCC') ? undefined : json['showPCC'],
        'showSubscriptionKey': !exists(json, 'showSubscriptionKey') ? undefined : json['showSubscriptionKey'],
        'showTarget': !exists(json, 'showTarget') ? undefined : json['showTarget'],
        'showB2BAPIUserPassword': !exists(json, 'showB2BAPIUserPassword') ? undefined : json['showB2BAPIUserPassword'],
        'showB2BAPIUserEmailAddress': !exists(json, 'showB2BAPIUserEmailAddress') ? undefined : json['showB2BAPIUserEmailAddress'],
        'showServiceUrl': !exists(json, 'showServiceUrl') ? undefined : json['showServiceUrl'],
        'showClientId': !exists(json, 'showClientId') ? undefined : json['showClientId'],
        'showClientSecret': !exists(json, 'showClientSecret') ? undefined : json['showClientSecret'],
        'showAuthenticationUrl': !exists(json, 'showAuthenticationUrl') ? undefined : json['showAuthenticationUrl'],
        'showAccessGroup': !exists(json, 'showAccessGroup') ? undefined : json['showAccessGroup'],
        'showShoppingUrl': !exists(json, 'showShoppingUrl') ? undefined : json['showShoppingUrl'],
        'showShoppingClientId': !exists(json, 'showShoppingClientId') ? undefined : json['showShoppingClientId'],
        'showShoppingClientSecret': !exists(json, 'showShoppingClientSecret') ? undefined : json['showShoppingClientSecret'],
        'showShoppingServiceUrl': !exists(json, 'showShoppingServiceUrl') ? undefined : json['showShoppingServiceUrl'],
        'showPostShoppingUrl': !exists(json, 'showPostShoppingUrl') ? undefined : json['showPostShoppingUrl'],
        'showPostShoppingClientId': !exists(json, 'showPostShoppingClientId') ? undefined : json['showPostShoppingClientId'],
        'showPostShoppingClientSecret': !exists(json, 'showPostShoppingClientSecret') ? undefined : json['showPostShoppingClientSecret'],
        'showPostShoppingServiceUrl': !exists(json, 'showPostShoppingServiceUrl') ? undefined : json['showPostShoppingServiceUrl'],
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function ProviderCredentialV2FormConfigurationToJSON(value?: ProviderCredentialV2FormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showTargetBranch': value.showTargetBranch,
        'showAgencyId': value.showAgencyId,
        'showAgentName': value.showAgentName,
        'showAgentPassword': value.showAgentPassword,
        'showPCC': value.showPCC,
        'showSubscriptionKey': value.showSubscriptionKey,
        'showTarget': value.showTarget,
        'showB2BAPIUserPassword': value.showB2BAPIUserPassword,
        'showB2BAPIUserEmailAddress': value.showB2BAPIUserEmailAddress,
        'showServiceUrl': value.showServiceUrl,
        'showClientId': value.showClientId,
        'showClientSecret': value.showClientSecret,
        'showAuthenticationUrl': value.showAuthenticationUrl,
        'showAccessGroup': value.showAccessGroup,
        'showShoppingUrl': value.showShoppingUrl,
        'showShoppingClientId': value.showShoppingClientId,
        'showShoppingClientSecret': value.showShoppingClientSecret,
        'showShoppingServiceUrl': value.showShoppingServiceUrl,
        'showPostShoppingUrl': value.showPostShoppingUrl,
        'showPostShoppingClientId': value.showPostShoppingClientId,
        'showPostShoppingClientSecret': value.showPostShoppingClientSecret,
        'showPostShoppingServiceUrl': value.showPostShoppingServiceUrl,
    };
}


